import { render, staticRenderFns } from "./ProfilePersonalInfoForm.vue?vue&type=template&id=f4c6fcaa&"
import script from "./ProfilePersonalInfoForm.vue?vue&type=script&lang=js&"
export * from "./ProfilePersonalInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports